@if (reducedFormat) {
<div>
  @if (!isAssignmentEncrypted) {
  <div class="address-line">
    @if (address?.address1) {
    <div class="d-inline">{{ address?.address1 }}</div>
    } @if (address?.address2) {
    <div class="d-inline">{{ ', ' + address?.address2 }}</div>
    } @if (address?.address3) {
    <div class="d-inline">{{ ', ' + address?.address3 }}</div>
    } @if (address?.address4) {
    <div class="d-inline">{{ ', ' + address?.address4 }}</div>
    }
  </div>
  }
  <div class="address-line">
    @if (address?.city) {
    <div class="d-inline">{{ address?.city }}</div>
    } @if (address?.county) {
    <div class="d-inline">{{ ', ' + address?.county }}</div>
    } @if (address?.postal_code) {
    <div class="d-inline">{{ ', ' + address?.postal_code }}</div>
    } @if (address?.country_name) {
    <div class="d-inline">{{ ', ' + address?.country_name }}</div>
    }
  </div>
</div>
} @else {
<span class="name">{{ address?.name }}</span>
<span class="address-line">{{ address?.salutation }}</span>
@if (!isAssignmentEncrypted) {
<span class="address-line">{{ address?.address1 }}</span>
} @if (!isAssignmentEncrypted) {
<span class="address-line">{{ address?.address2 }}</span>
} @if (!isAssignmentEncrypted) {
<span class="address-line">{{ address?.address3 }}</span>
} @if (!isAssignmentEncrypted) {
<span class="address-line">{{ address?.address4 }}</span>
}
<span class="address-line">{{ address?.city }}</span>
<span class="address-line">{{ address?.county }}</span>
<span class="address-line">{{ address?.postal_code }}</span>
<span class="address-line">{{ address?.country_name }}</span>
}
